module.exports = [
  // {
  //   author: 'Director of Talent, Protection Connection, Inc.',
  //   body: "We're trying to hire 10 financial salespeople a week for our office, which is especially challenging as we're not located in a big metro area and we've found that recent college grads perform well and there just aren't many in this area. We found College Recruiter online, contacted them for pricing, they responded quickly and recommended a month-to-month pilot of a JobsThatScale, job posting campaign. We've already hired two people and the pilot only launched 1.5 weeks ago!",
  //   image: {
  //     fileName: 'your-protection-connection.png',
  //     width: 155,
  //     height: 92,
  //     alt: 'Your Protection Connection Logo'
  //   }
  // },
  {
    author: 'Executive Director, Talent Tech Labs',
    body: 'We posted the same paid internship with a bunch of job boards but half of all of the applicants and both of the hires came from College Recruiter',
    image: {
      fileName: 'talent-tech-labs.png',
      width: 155,
      height: 24,
      alt: 'Talent Tech Labs Logo'
    }
  },
  {
    author: 'Campus Relations, Intel',
    body: 'We are very happy with the results from your JobsThatScale product. We met all our goals with you leading us and again are very pleased.',
    image: {
      fileName: 'intel.jpeg',
      width: 155,
      height: 144,
      alt: 'Intel Logo'
    }
  },
  {
    author:
      "Kara Yarnot, member of College Recruiter's board of advisors, executive consultant and strategy consulting leader with Hireclix LLC, co-founder Meritage Talent Solutions",
    body: "I was completely blown away by College Recruiter's data and analytics product.",
    image: {
      fileName: 'hireclix.jpeg',
      width: 155,
      height: 44,
      alt: 'Hireclix Logo'
    }
  },
  {
    author: 'Manager of Interactive Media, SAP Successfactors',
    body: 'College Recruiter is a proven leader in web 2.0 recruitment strategies for the collegiate and early career industry.',
    image: {
      fileName: 'sap-successfactors.png',
      width: 155,
      height: 18,
      alt: 'SAP Successfactors Logo'
    }
  },
  {
    author: 'University Relations and Recruiting Coordinator, HGST, a Western Digital Company',
    body: 'College Recruiter has been working as a great resource for our Talent Acquisition team! Our inbox has been flooded with applications from quality candidates, a bit overwhelming but we will take it!',
    image: {
      fileName: 'hgst.jpeg',
      width: 155,
      height: 53,
      alt: 'HGST Logo'
    }
  },
  // {
  //   author: 'Director of Human Resources, Sequoia Financial',
  //   body: "We've tried several ways to recruit college students for our entry level positions including job postings on other leading college job boards. None worked well so we were skeptical when first approached by College Recruiter...(Your) approach in having the job posted to our area rather than to a handful of schools proved to generate far more responses than the postings on the other sites. ..it really works!!!!",
  //   image: {
  //     fileName: 'sequoia.jpeg',
  //     width: 150,
  //     height: 123,
  //     alt: 'Sequoia Financial Logo'
  //   }
  // },
  {
    author: 'Recruitment Center, Central Intelligence Agency',
    body: 'The support that you provide is outstanding. Thanks!',
    image: {
      fileName: 'cia.jpeg',
      width: 100,
      height: 86,
      alt: 'CIA Logo'
    }
  }
  // {
  //   author: 'Recruiter, Leapforce, Inc.',
  //   body: 'We run job posting ads on a lot of sites but had never used College Recruiter until we purchased an unlimited job posting package a month ago. We were amazed at the high quantity and quality of responses that we received. After only two days, we had a positive return on our investment for the entire month.',
  //   image: {
  //     fileName: 'leapforce.jpeg',
  //     width: 94,
  //     height: 100,
  //     alt: 'Leapforce Logo'
  //   }
  // }
];
